import { UtilityMethods } from "@mindmemobile/mm-shared-global";
import { ItemBillingEnds, ItemBillingEndsAfterInterval, SubscriptionStatus } from "../enums";
import { IAPISubscriptionGridModel } from "../interfaces";
import { ContactReferenceModel } from "./ContactDetailPageModel";

export class SubscriptionGridModel {
    id: string;
    nextDue: Date;
    status: keyof typeof SubscriptionStatus;
    description: string;
    pastDueDays: number;
    billingIntervalCount: number;
    billingInterval: string;
    contact?: ContactReferenceModel;
    nextAmount: number;
    cancelOn?: Date | null;
    billingEndsInterval: keyof typeof ItemBillingEnds;
    billingEndsAfterInterval: keyof typeof ItemBillingEndsAfterInterval;
    billingEndIntervalCount: number;

    constructor(data?: Partial<SubscriptionGridModel>) {
        this.id = (data && data.id) || '';
        this.nextDue = (data && data.nextDue) || new Date();
        this.status = (data && data.status) || SubscriptionStatus.Active;
        this.description = (data && data.description) || '';
        this.pastDueDays = (data && data.pastDueDays) || 0;
        this.billingIntervalCount = (data && data.billingIntervalCount) || 0;
        this.billingInterval = (data && data.billingInterval) || '';
        this.contact = (data && data.contact && new ContactReferenceModel(data.contact)) || undefined;
        this.nextAmount = (data && data.nextAmount) || 0;
        this.cancelOn = (data && data.cancelOn) || undefined;
        this.billingEndsInterval = data?.billingEndsInterval || ItemBillingEnds.After;
        this.billingEndsAfterInterval =
            data?.billingEndsAfterInterval ||
            (Object.keys(ItemBillingEndsAfterInterval)[0] as keyof typeof ItemBillingEndsAfterInterval);
        this.billingEndIntervalCount = (data && data.billingEndIntervalCount) || 0;
    }

    static deserializeAPIModel(data: IAPISubscriptionGridModel): SubscriptionGridModel {
        const mappedData: Partial<SubscriptionGridModel> = {
            id: data.id,
            nextDue: new Date(data.nextDue.replace('Z', '')),
            status: data.status,
            description: data.description,
            pastDueDays: data.pastDueDays,
            billingIntervalCount: data.billingIntervalCount,
            billingInterval: data.billingInterval,
            contact: data.contactDetails && ContactReferenceModel.deserializeAPIModel(data.contactDetails),
            nextAmount: data.nextAmount,
            cancelOn: data.cancelOn ? UtilityMethods.removeZFromDateString(data.cancelOn) : null,
            billingEndsInterval: data.billingEndsInterval,
            billingEndsAfterInterval: data.billingEndsAfterInterval,
            billingEndIntervalCount: data.billingEndIntervalCount,
        };
        return new SubscriptionGridModel(mappedData);
    }
}
